// services/voucherTypeFinanceMasterService.ts

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const voucherTypeFinanceMasterService = createApi({
  reducerPath: "voucherTypeFinanceMasterService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["voucherTypeFinanceMaster"],
  endpoints: (builder) => ({
    getAllVoucherTypeFinanceMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherTypeFinanceMasterController.getAllPaginated}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    searchVoucherTypeFinanceMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherTypeFinanceMasterController.search}`,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    saveVoucherTypeFinanceMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherTypeFinanceMasterController.save}`,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    updateVoucherTypeFinanceMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherTypeFinanceMasterController.update}/${body.id}`,
        method: "PUT",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    deleteVoucherTypeFinanceMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherTypeFinanceMasterController.delete}/${body.id}`,
        method: "DELETE",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    getVoucherTypeFinanceMasterById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherTypeFinanceMasterController.getById}/${body.id}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    getAllVoucherTypeFinanceMasterList: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherTypeFinanceMasterController.getAll}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    uploadBulkVoucherTypeFinanceMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherTypeFinanceMasterController.uploadBulk}`,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
  }),
});

export const {
  useGetAllVoucherTypeFinanceMasterMutation,
  useSearchVoucherTypeFinanceMasterMutation,
  useSaveVoucherTypeFinanceMasterMutation,
  useUpdateVoucherTypeFinanceMasterMutation,
  useDeleteVoucherTypeFinanceMasterMutation,
  useGetVoucherTypeFinanceMasterByIdMutation,
  useGetAllVoucherTypeFinanceMasterListMutation,
  useUploadBulkVoucherTypeFinanceMasterMutation,
} = voucherTypeFinanceMasterService;
